// extracted by mini-css-extract-plugin
module.exports = {"blogPage":"BlogPage_blogPage___hZlB","blogPageContentWrapper":"BlogPage_blogPageContentWrapper__6BsrC"};